export default __webpack_public_path__ + "static/media/orqafara.1aefa9f2.jpg";